import { create } from "zustand";

export interface BreadCrumbRouteProps {
  label: string;
  path: string;
}

export type ReplaceBreadCrumbRouteProps = Record<string, BreadCrumbRouteProps>;

export interface BreadcrumbStore {
  overrides: ReplaceBreadCrumbRouteProps;
  setOverride: (pathKey: string, value: BreadCrumbRouteProps) => void;
  removeOverride: (pathKey: string) => void;
  clearOverrides: () => void;
  reset: () => void;
}

const initialState: Pick<BreadcrumbStore, "overrides"> = {
  overrides: {},
};

export const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  ...initialState,

  setOverride: (pathKey, value) =>
    set((state) => ({
      overrides: {
        ...state.overrides,
        [pathKey]: value,
      },
    })),

  removeOverride: (pathKey) =>
    set((state) => {
      const { [pathKey]: _, ...rest } = state.overrides;
      return { overrides: rest };
    }),

  clearOverrides: () => set({ overrides: {} }),

  reset: () => set(initialState),
}));
